import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { cn } from '../../lib/cn';
import type { HydratedBlogPost } from '../../types/blog';
import { getBlogCtaTarget } from '../../../lib/blogHubLinks';

interface BlogCtaCardProps {
    /**
     * Optional className override merged into the outer <section>. Use to
     * override the default `mt-16` top spacing when a host page's rhythm
     * needs a different gap (e.g. the listing pages set `mt-12` so the
     * top gap matches their 48px bottom-of-container gap to the Footer).
     */
    className?: string;
    /**
     * Optional source post (item 5). When present AND tagged (item 10), the CTA targets the
     * post's primary-tag directory hub (style → buildStyleUrl, else region → buildDirectoryUrl,
     * suburb-less style → the /nsw/gyms floor). Absent or untagged → the generic /gyms +
     * triggerFilters — inert on the /gyms chooser since UI-57 (the ruled landing:
 * pills carry the style onward); still live on directory-space targets.
     */
    post?: HydratedBlogPost;
}

const BlogCtaCard: React.FC<BlogCtaCardProps> = ({ className, post }) => {
    const target = getBlogCtaTarget(post);

    return (
        <section aria-labelledby="blog-cta-heading" className={cn("mt-16", className)}>
            {/* Desktop: text-left / button-right (fills the wide banner's right space);
                mobile: stacks (button under the text), preserving the mobile layout. */}
            <div className="bg-brand-primary rounded-2xl p-8 md:p-10 md:flex md:items-center md:justify-between md:gap-8">
                <div>
                    <h2 id="blog-cta-heading" className="text-text-inverse text-2xl md:text-3xl font-bold mb-3">
                        Ready to find your gym?
                    </h2>
                    <p className="text-text-inverse/90 text-base md:text-lg mb-6 md:mb-0">
                        Search 2,600+ gyms across NSW and VIC on Martial Arts Network.
                    </p>
                </div>
                <Button
                    variant="secondary"
                    className="w-full md:w-auto bg-surface-base text-brand-primary hover:bg-surface-canvas border-transparent md:flex-shrink-0"
                    asChild
                >
                    <Link
                        to={target.href}
                        state={target.triggerFilters ? { triggerFilters: true } : undefined}
                    >
                        Search gyms →
                    </Link>
                </Button>
            </div>
        </section>
    );
};

export default BlogCtaCard;
